export default __webpack_public_path__ + "static/media/radio_selected.3cce5105.svg";